import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "content",
  style: {
    "min-width": "80%"
  }
};
const _hoisted_2 = {
  class: "tabLists"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 0,
  class: "top_info"
};
const _hoisted_5 = {
  class: "img_info info_dom"
};
const _hoisted_6 = {
  class: "img_info_body"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  style: {
    "text-indent": "32px",
    "display": "inline-block"
  }
};
const _hoisted_9 = {
  class: "info_dom",
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between"
  }
};
const _hoisted_10 = ["onMouseenter", "onClick"];
const _hoisted_11 = {
  style: {
    "text-indent": "32px",
    "display": "inline-block"
  }
};
const _hoisted_12 = {
  class: "learn-more-box"
};
const _hoisted_13 = {
  class: "vido_list"
};
const _hoisted_14 = {
  class: "vido_list_l"
};
const _hoisted_15 = {
  class: "list"
};
const _hoisted_16 = {
  class: "vido_dom"
};
const _hoisted_17 = {
  class: "dome_img"
};
const _hoisted_18 = {
  class: "vido_dom_img"
};
const _hoisted_19 = ["src", "onClick"];
const _hoisted_20 = {
  class: "vido_dom_text"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "vido_tip"
};
const _hoisted_23 = {
  key: 1,
  class: "Expert_Popularization"
};
const _hoisted_24 = {
  class: "Popularization_list"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  style: {
    "color": "#cbcbcb"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_popup = _resolveComponent("popup");
  const _component_science_m = _resolveComponent("science_m");
  return $setup.Client == 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle([{
      "min-width": "1560px"
    }, 'zoom:' + ($setup.Client ? '20%' : '') + ';' + 'border-top:1px solid #E3E3E3;']),
    class: "body"
  }, [_createElementVNode("div", _hoisted_1, [_cache[9] || (_cache[9] = _createElementVNode("h1", null, "口腔健康科普以及术后注意事项", -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabList, (item, index) => {
    return _openBlock(), _createElementBlock("span", {
      key: index,
      style: _normalizeStyle('color:' + ($setup.tabIndex == index ? '#23A5C8;' : '#000;')),
      onClick: $event => $setup.tabClick(index)
    }, _toDisplayString(item.name), 13, _hoisted_3);
  }), 128))]), $setup.get_data.top?.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    src: $setup.get_data.top[$setup.select_index].imgUrl,
    alt: ""
  }, null, 8, _hoisted_7)]), _createElementVNode("div", {
    class: "info_option",
    style: _normalizeStyle('color:' + ($setup.select_index == 0 ? '#16A1C3;' : '#000;') + 'border-bottom:5px solid ' + ($setup.select_index == 0 ? '#16A1C3;' : '#DBF2F3;')),
    onMouseenter: _cache[0] || (_cache[0] = $event => $setup.info_option(0)),
    onClick: _cache[1] || (_cache[1] = $event => $setup.details($setup.get_data.top[0].id, '0'))
  }, [_createElementVNode("h3", null, _toDisplayString($setup.get_data.top[0].title), 1), _createElementVNode("span", _hoisted_8, _toDisplayString($setup.get_data.top[0].brief), 1)], 36)]), _createElementVNode("div", _hoisted_9, [_cache[6] || (_cache[6] = _createElementVNode("div", {
    style: {
      "width": "80px",
      "background": "#12A4C0",
      "height": "10px"
    }
  }, null, -1)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
    return _createElementVNode("div", {
      class: "info_option",
      style: _normalizeStyle('color:' + ($setup.select_index == index + 1 ? '#16A1C3;' : '#000;') + 'border-bottom:5px solid ' + ($setup.select_index == index + 1 ? '#16A1C3;' : '#DBF2F3;')),
      onMouseenter: $event => $setup.info_option(index + 1),
      onClick: $event => $setup.details($setup.get_data.top[index + 1].id, '0')
    }, [_createElementVNode("h3", null, _toDisplayString($setup.get_data.top[index + 1].title), 1), _createElementVNode("span", _hoisted_11, _toDisplayString($setup.get_data.top[index + 1].brief), 1)], 44, _hoisted_10);
  }), 64))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "learn-more",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.learnMore && $setup.learnMore(...args))
  }, "了解更多")]), _createVNode(_component_popup, {
    show: $setup.loginShow,
    showState: $setup.showState,
    onModifyShowState: $setup.modifyShowState,
    onGetUserData: $setup.getUserData
  }, null, 8, ["show", "showState", "onModifyShowState", "onGetUserData"]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("h2", null, _toDisplayString($setup.tabList[$setup.tabIndex].name) + "注意事项", 1), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data.boot, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("h3", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
      src: item.imgUrl,
      onClick: $event => $setup.details(item.id, index)
    }, null, 8, _hoisted_19)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("span", {
      onClick: _cache[3] || (_cache[3] = (...args) => $setup.show && $setup.show(...args))
    }, "联系我们"), _createElementVNode("span", {
      onClick: $event => $setup.details(item.id, index)
    }, "术后指引", 8, _hoisted_21)])])]);
  }), 256))])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", {
    style: {
      "margin-bottom": "20px"
    },
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.more && $setup.more(...args))
  }, _cache[7] || (_cache[7] = [_createElementVNode("span", null, [_createElementVNode("img", {
    style: {
      "width": "24px",
      "height": "24px",
      "vertical-align": "text-bottom",
      "margin-right": "8px"
    },
    src: "https://www.mimodental.com/assets/imgData/img/science/apply.png",
    alt: ""
  }), _createTextVNode(" 为什么选择米檬 ")], -1)])), _createElementVNode("div", {
    onClick: _cache[5] || (_cache[5] = (...args) => $setup.findCon && $setup.findCon(...args))
  }, _cache[8] || (_cache[8] = [_createElementVNode("span", null, [_createElementVNode("img", {
    style: {
      "width": "24px",
      "height": "24px",
      "vertical-align": "text-bottom",
      "margin-right": "8px"
    },
    src: "https://www.mimodental.com/assets/imgData/img/science/apply.png",
    alt: ""
  }), _createTextVNode(" 查找疾病与状况 ")], -1)]))])]), $setup.answer.length ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("h2", null, _toDisplayString($setup.tabList[$setup.tabIndex].name) + "解答", 1), _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.answer, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $setup.details(item.id, index)
    }, [_createElementVNode("span", null, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_26, _toDisplayString(item.createTime), 1)], 8, _hoisted_25);
  }), 128))])])) : _createCommentVNode("", true)])], 4)) : (_openBlock(), _createBlock(_component_science_m, {
    key: 1
  }));
}